export const unreachable = t => {
  throw new Error("this was supposed to be unreachable ".concat(t));
};
export const unreachableWithReturn = (_, value) => {
  return value;
};